/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, IconButton} from "@mui/material";
import logo from "../../Recursos/logo_barra.svg";
import {useNavigate} from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import Boton_Barra_Cell from "../Secciones/Componentes/SubComponentes/Boton_Barra_Cell";

const BarraCell = () => {
    const navigate = useNavigate()

    return (
        <Grid2
            container
            justifyContent={'space-between'}
            alignItems={'center'}
            position="absolute"
            size={12}
            sx={{my: 2}}>
            <Grid2 container

                   size={12}
                   sx={{mx: 2}}>

                <Grid2 container size={8}>
                    <img
                        onClick={() => navigate('/Home')}
                        src={logo} width={'50%'} height={'auto'}
                        style={{cursor: 'pointer'}}/>
                </Grid2>

                <Grid2 container size={4}>
                    <Boton_Barra_Cell />
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default BarraCell;